namespace Gamification.Gamification {
    export interface ApiComandiRow {
        IdApiComando?: number;
        IdApi?: number;
        IdApiOperazione?: number;
        Comando?: string;
        Descrizione?: string;
        IdApiNome?: string;
        IdApiDescrizione?: string;
        IdApiOperazioneIdApiTipoOperazione?: number;
        IdApiOperazioneNome?: string;
        IdApiOperazioneDescrizione?: string;
        IdApiOperazioneIdApiTipoOperazioneNome?: string;
    }

    export namespace ApiComandiRow {
        export const idProperty = 'IdApiComando';
        export const nameProperty = 'Comando';
        export const localTextPrefix = 'Gamification.ApiComandi';
        export const lookupKey = 'Gamification.ApiComandi';

        export function getLookup(): Q.Lookup<ApiComandiRow> {
            return Q.getLookup<ApiComandiRow>('Gamification.ApiComandi');
        }
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdApiComando = "IdApiComando",
            IdApi = "IdApi",
            IdApiOperazione = "IdApiOperazione",
            Comando = "Comando",
            Descrizione = "Descrizione",
            IdApiNome = "IdApiNome",
            IdApiDescrizione = "IdApiDescrizione",
            IdApiOperazioneIdApiTipoOperazione = "IdApiOperazioneIdApiTipoOperazione",
            IdApiOperazioneNome = "IdApiOperazioneNome",
            IdApiOperazioneDescrizione = "IdApiOperazioneDescrizione",
            IdApiOperazioneIdApiTipoOperazioneNome = "IdApiOperazioneIdApiTipoOperazioneNome"
        }
    }
}
